var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { key: _vm.key }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "BetSlip.dialog.confirm.title." + _vm.dialogBetslipConfirm.data
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dialog_text" }, [
        _c("p", { key: _vm.key }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t(
                  "BetSlip.dialog.confirm.msg." + _vm.dialogBetslipConfirm.data,
                  {
                    n:
                      _vm.dialogBetslipConfirm.data &&
                      _vm.dialogBetslipConfirm.data[1]
                  }
                )
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("BetSlip.dialog.confirm.areYouSure")))])
      ]),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c("v-flex", { attrs: { xs6: "" } }, [
            _c(
              "button",
              {
                staticClass: "v-btn primary",
                on: {
                  click: function($event) {
                    return _vm.cancelAction()
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("BetSlip.dialog.confirm.CANCEL")))
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs6: "" } }, [
            _c(
              "button",
              {
                staticClass: "v-btn secondary",
                on: {
                  click: function($event) {
                    return _vm.confirmAction()
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("BetSlip.dialog.confirm.OK")))
                ])
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-699f84ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-699f84ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/rootElements/betslipConfirm.vue
// module id = null
// module chunks = 